import { Result } from 'entities/result'

import Logo from 'components/../../public/logo_h.png'
import CoverImage from 'api/../../public/result_v2/result1.jpg'
import TopImage from 'api/../../public/result_v2/result2.jpg'
import Ovary1 from 'api/../../public/result_v2/ovary/ovary1.jpg'
import Ovary2 from 'api/../../public/result_v2/ovary/ovary2.jpg'
import Ovary3 from 'api/../../public/result_v2/ovary/ovary3.jpg'
import Ovary4 from 'api/../../public/result_v2/ovary/ovary4.jpg'
import PcrOvaryPlotBg from 'api/../../public/result_v2/ovary/pcr/ovary_plot.png'
import NgsOvaryPlotBg from 'api/../../public/result_v2/ovary/ngs/ovary_plot.png'

import Breast1 from 'api/../../public/result_v2/breast/breast1.jpg'
import Breast2 from 'api/../../public/result_v2/breast/breast2.jpg'
import Breast3 from 'api/../../public/result_v2/breast/breast3.jpg'
import Breast4 from 'api/../../public/result_v2/breast/breast4.jpg'
import PcrBreastPlotBg from 'api/../../public/result_v2/breast/pcr/breast_plot.png'
import NgsBreastPlotBg from 'api/../../public/result_v2/breast/ngs/breast_plot.png'

import Lung1 from 'api/../../public/result_v2/lung/lung1.jpg'
import Lung2 from 'api/../../public/result_v2/lung/lung2.jpg'
import Lung3 from 'api/../../public/result_v2/lung/lung3.jpg'
import Lung4 from 'api/../../public/result_v2/lung/lung4.jpg'
import PcrLungPlotMaleBg from 'api/../../public/result_v2/lung/pcr/lung_plot_male.png'
import PcrLungPlotFemaleBg from 'api/../../public/result_v2/lung/pcr/lung_plot_female.png'
import NgsLungPlotMaleBg from 'api/../../public/result_v2/lung/ngs/lung_plot_male.png'
import NgsLungPlotFemaleBg from 'api/../../public/result_v2/lung/ngs/lung_plot_female.png'

import Stomach1 from 'api/../../public/result_v2/stomach/stomach1.jpg'
import Stomach2 from 'api/../../public/result_v2/stomach/stomach2.jpg'
import Stomach3 from 'api/../../public/result_v2/stomach/stomach3.jpg'
import Stomach4 from 'api/../../public/result_v2/stomach/stomach4.jpg'
import PcrStomachPlotMaleBg from 'api/../../public/result_v2/stomach/pcr/stomach_plot_male.png'
import PcrStomachPlotFemaleBg from 'api/../../public/result_v2/stomach/pcr/stomach_plot_female.png'
import NgsStomachPlotMaleBg from 'api/../../public/result_v2/stomach/ngs/stomach_plot_male.png'
import NgsStomachPlotFemaleBg from 'api/../../public/result_v2/stomach/ngs/stomach_plot_female.png'

import Colorectal1 from 'api/../../public/result_v2/colorectal/colorectal1.jpg'
import Colorectal2 from 'api/../../public/result_v2/colorectal/colorectal2.jpg'
import Colorectal3 from 'api/../../public/result_v2/colorectal/colorectal3.jpg'
import Colorectal4 from 'api/../../public/result_v2/colorectal/colorectal4.jpg'
import PcrColorectalPlotMaleBg from 'api/../../public/result_v2/colorectal/pcr/colorectal_plot_male.png'
import PcrColorectalPlotFemaleBg from 'api/../../public/result_v2/colorectal/pcr/colorectal_plot_female.png'
import NgsColorectalPlotMaleBg from 'api/../../public/result_v2/colorectal/ngs/colorectal_plot_male.png'
import NgsColorectalPlotFemaleBg from 'api/../../public/result_v2/colorectal/ngs/colorectal_plot_female.png'

import Esophagus1 from 'api/../../public/result_v2/esophagus/esophagus1.jpg'
import Esophagus2 from 'api/../../public/result_v2/esophagus/esophagus2.jpg'
import Esophagus3 from 'api/../../public/result_v2/esophagus/esophagus3.jpg'
import Esophagus4 from 'api/../../public/result_v2/esophagus/esophagus4.jpg'
import PcrEsophagusPlotMaleBg from 'api/../../public/result_v2/esophagus/pcr/esophagus_plot_male.png'
import PcrEsophagusPlotFemaleBg from 'api/../../public/result_v2/esophagus/pcr/esophagus_plot_female.png'
import NgsEsophagusPlotMaleBg from 'api/../../public/result_v2/esophagus/ngs/esophagus_plot_male.png'
import NgsEsophagusPlotFemaleBg from 'api/../../public/result_v2/esophagus/ngs/esophagus_plot_female.png'

import Pancreas1 from 'api/../../public/result_v2/pancreas/pancreas1.jpg'
import Pancreas2 from 'api/../../public/result_v2/pancreas/pancreas2.jpg'
import Pancreas3 from 'api/../../public/result_v2/pancreas/pancreas3.jpg'
import Pancreas4 from 'api/../../public/result_v2/pancreas/pancreas4.jpg'
import PcrPancreasPlotMaleBg from 'api/../../public/result_v2/pancreas/pcr/pancreas_plot_male.png'
import PcrPancreasPlotFemaleBg from 'api/../../public/result_v2/pancreas/pcr/pancreas_plot_female.png'
import NgsPancreasPlotMaleBg from 'api/../../public/result_v2/pancreas/ngs/pancreas_plot_male.png'
import NgsPancreasPlotFemaleBg from 'api/../../public/result_v2/pancreas/ngs/pancreas_plot_female.png'

import { Sample } from 'entities/sample'
import { A4 } from 'components/shared/print'
import { PatientViewModel } from 'view_models/patient_view_model'
import { toDateText } from 'utils/util'
import { ResultV2ViewModel, RiskDataItem } from 'view_models/result_v2/result_v2_view_model'
import { CSSProperties } from 'styled-components'
import { Flex } from 'components/shared/flex'
import { RiskLevel } from 'view_models/result_view_model'
import moment from 'moment'
import { InstitutionViewModel } from 'view_models/institution_view_model'
import { SampleViewModel } from 'view_models/sample_view_model'
import { BreastResultV2ViewModel, BreastRiskScore } from 'view_models/result_v2/breast_result_v2_view_model'
import { OvaryResultV2ViewModel, OvaryRiskScore } from 'view_models/result_v2/ovary_result_v2_view_model'
import { ResultV2ViewModelFactory } from 'view_models/result_v2/result_v2_factory'
import { ceil } from 'mathjs'
import { Cancer, ProductItem } from 'entities/product_item'
import QRCode from 'qrcode.react'
import { LungResultV2ViewModel, LungRiskScore } from 'view_models/result_v2/lung_result_v2_view_model'
import { StomachResultV2ViewModel, StomachRiskScore } from 'view_models/result_v2/stomach_result_v2_view_model'
import { ColorectalResultV2ViewModel, ColorectalRiskScore } from 'view_models/result_v2/colorectal_result_v2_view_model'
import { EsophagusResultV2ViewModel, EsophagusRiskScore } from 'view_models/result_v2/esophagus_result_v2_view_model'
import { PancreasResultV2ViewModel, PancreasRiskScore } from 'view_models/result_v2/pancreas_result_v2_view_model'
import { useEffectSkipFirst, useForm, useQuery } from 'utils/hooks'
import { CheckboxField } from 'components/shared/input'
import { Barcode } from 'components/shared/widget'

const OvaryImages = [Ovary1, Ovary2, Ovary3, Ovary4, PcrOvaryPlotBg, PcrOvaryPlotBg, NgsOvaryPlotBg, NgsOvaryPlotBg]
const BreastImages = [Breast1, Breast2, Breast3, Breast4, PcrBreastPlotBg, PcrBreastPlotBg, NgsBreastPlotBg, NgsBreastPlotBg]
const LungImages = [Lung1, Lung2, Lung3, Lung4, PcrLungPlotMaleBg, PcrLungPlotFemaleBg, NgsLungPlotMaleBg, NgsLungPlotFemaleBg]
const StomachImages = [Stomach1, Stomach2, Stomach3, Stomach4, PcrStomachPlotMaleBg, PcrStomachPlotFemaleBg, NgsStomachPlotMaleBg, NgsStomachPlotFemaleBg]
const ColorectalImages = [Colorectal1, Colorectal2, Colorectal3, Colorectal4, PcrColorectalPlotMaleBg, PcrColorectalPlotFemaleBg, NgsColorectalPlotMaleBg, NgsColorectalPlotFemaleBg]
const EsophagusImages = [Esophagus1, Esophagus2, Esophagus3, Esophagus4, PcrEsophagusPlotMaleBg, PcrEsophagusPlotFemaleBg, NgsEsophagusPlotMaleBg, NgsEsophagusPlotFemaleBg]
const PancreasImages = [Pancreas1, Pancreas2, Pancreas3, Pancreas4, PcrPancreasPlotMaleBg, PcrPancreasPlotFemaleBg, NgsPancreasPlotMaleBg, NgsPancreasPlotFemaleBg]

export type ResultV2Props = {
    sample: Sample
    result?: Result
    onlyResult?: boolean
    symptoms: Symptom[]
    inspectionMethod?: "PCR" | "NGS"
}

export const ResultV2 = (props: ResultV2Props) => {
    const getImages = () => {
        const productName = props.result?.productItem?.nameEn
        if (productName === 'ovary') {
            return OvaryImages
        } else if (productName === 'breast') {
            return BreastImages
        } else if (productName === 'lung') {
            return LungImages
        } else if (productName === 'stomach') {
            return StomachImages
        } else if (productName === 'colorectal') {
            return ColorectalImages
        } else if (productName === 'esophagus') {
            return EsophagusImages
        } else if (productName === 'pancreas') {
            return PancreasImages
        } else {
            return []
        }
    }

    if (props.symptoms.length === 0) {
        return <></>
    }

    try {
        const resultVm = props.result ? ResultV2ViewModelFactory.create(props.result, props.sample) : undefined
        const prevResults = props.result?.prevResults ?? []
        const prevResultVm = prevResults[0] ? ResultV2ViewModelFactory.create(prevResults[0], props.sample) : undefined
        const prev2ResultVm = prevResults[1] ? ResultV2ViewModelFactory.create(prevResults[1], props.sample) : undefined
        const images = getImages()
        return (
            <div className="preview-result-v2" id={resultVm?.object.productItem?.nameEn}>
                {/* {!props.onlyResult && <ResultGuidancePaperV2 sample={props.sample} />} */}
                <>
                    {Image1(
                        images[0],
                        props.inspectionMethod === 'PCR' ?
                            props.sample.patient?.gender === 'MALE' ? images[4] : images[5] :
                            props.sample.patient?.gender === 'MALE' ? images[6] : images[7]
                        ,
                        props.sample,
                        props.symptoms,
                        resultVm,
                        prevResultVm,
                        prev2ResultVm
                    )}
                    {Image2(images[1], props.sample, resultVm, prevResultVm, prev2ResultVm)}
                    {Image3(images[2], props.sample, resultVm, prevResultVm, prev2ResultVm)}
                    {Image4(images[3], props.sample, props.symptoms, resultVm)}
                </>
            </div>
        )
    } catch (e) {
        return (
            <div>
                データが正しくありません。背景情報が不足している可能性があります<br></br>
                {String(e)}
            </div>
        )
    }
}

type ResultGuidancePaperV2Props = {
    sample: Sample
}

export const ResultGuidancePaperV2 = (props: ResultGuidancePaperV2Props) => {
    const { sample } = props
    const instVm = new InstitutionViewModel(sample.institution!)
    const patientVm = new PatientViewModel(sample.patient!)
    return (
        <A4 padding={0} landscape={false}>
            <div style={{ height: '6mm', width: '1mm' }}></div>
            <Flex style={{ padding: 55, borderBottom: 'solid 1px black' }} justifyContent="space-between">
                <div style={{ padding: 10, width: 350, height: 155, position: 'relative', fontSize: 14 }}>
                    <div>〒{instVm.addressVm().zipCode()}</div>
                    <div>{instVm.addressVm().whole({ showZipCode: false })}</div>
                    <div style={{ marginBottom: 30 }}>{instVm.object.name} 御中</div>
                </div>
                <div style={{ textAlign: 'right', position: 'relative' }}>
                    <img src={Logo} style={{ width: 230, objectFit: 'contain', position: 'absolute', top: -20, right: -20 }}></img>
                    <div style={{ textAlign: 'right', marginTop: 60 }}>
                        <div>〒464-0814 愛知県名古屋市千種区不老町1</div>
                        <div>NIC711・712号</div>
                        <div>Craif株式会社 中部検査センター</div>
                        <div>TEL: 070-3149-6278</div>
                    </div>
                </div>
            </Flex>
            <div style={{ padding: 45 }}>
                <div style={{ width: '100%', textAlign: 'center', fontSize: 21, fontWeight: 'bold', marginBottom: 40 }}>
                    <div>結果票送付のご案内</div>
                </div>
                <div style={{ marginBottom: 30 }}>
                    <div>拝啓 時下ますますご清栄のこととお慶び申し上げます。</div>
                    <div>
                        この度はmiSignal™をご利用くださいまして誠にありがとうございました。下記の通り患者様への検査結果票・ご案内と、医療機関様向けのご説明書をお送りいたしますので、患者様へのお渡し及びご説明のほど何卒宜しくお願いいたします。
                    </div>
                    <div style={{ textAlign: 'right' }}>敬具</div>
                </div>
                <div style={{ textAlign: 'center' }}>記</div>
                <div style={{ marginBottom: 40 }}>
                    {sample.productItems?.map((productItem) => (
                        <div key={`souhujo-result-${sample.id}-${productItem.id}`} style={{ marginTop: 30 }}>
                            <div>
                                患者様： ({sample.code}) - ({productItem.name?.replaceAll('がん', '')}) {patientVm.fullName()} 様
                            </div>
                            <table style={{ marginTop: 20 }}>
                                <tbody>
                                    <tr>
                                        <td style={{ width: 600 }}>
                                            <div>・miSignal™（{productItem.name}）結果票</div>
                                            <div style={{ marginBottom: 20 }}>(1通は医療機関様控えとして保管ください)</div>
                                        </td>
                                        <td>2 通</td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div style={{ marginBottom: 20 }}>・受検頂いた皆様へ</div>
                                        </td>
                                        <td>1 通</td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div style={{ marginBottom: 20 }}>・（医療機関様向け）miSignal™検査のご説明*</div>
                                        </td>
                                        <td>1 通</td>
                                    </tr>
                                </tbody>
                            </table>
                            <div style={{ marginTop: 40 }}>
                                (*)この資料は医療機関様向けです。患者様への説明資料ではございませんのでお渡しいただかないようご注意ください。
                                <br />
                                追加検査で他医療機関様をご紹介いただく場合に、紹介状に同封する形でご活用いただけます。
                            </div>
                        </div>
                    ))}
                </div>
                <div style={{ textAlign: 'right' }}>以上</div>
            </div>
        </A4>
    )
}

// 封筒の左上の窓枠サイズに合わせた住所表示の最大幅
const ENVELOPE_ADDRESS_WINDOW_MAX_WIDTH = 280

export const ResultCover = (props: { sample: Sample; isResultSendToPatient?: boolean }) => {
    const isHomeTest = process.env.REACT_APP_IS_HOME_TEST
    const patientVm = new PatientViewModel(props.sample.patient!)
    const institution = new InstitutionViewModel(props.sample.institution!)
    const hideForm = useForm<{ hideMedicalNote?: boolean }>({})
    const query = useQuery<{ showMedicalNote?: boolean }>()

    useEffectSkipFirst(() => {
        hideForm.updateObject('hideMedicalNote', false)
    }, [props.sample.id])

    return (
        <A4 padding={0} landscape={false}>
            <div className="page-root" style={{ width: '100.5%', height: '100%', position: 'relative' }}>
                <img src={CoverImage} style={{ objectFit: 'contain', width: '100%' }} />
                {props.sample.background?.medicalNote && query.showMedicalNote && !hideForm.object.hideMedicalNote && (
                    <div style={{ position: 'absolute', left: 57, top: 20, fontSize: 13, width: 670 }}>
                        <Flex>
                            <div>{props.sample.background?.medicalNote}</div>
                        </Flex>
                    </div>
                )}
                {props.sample.background?.medicalNote && (
                    <div style={{ position: 'absolute', right: 57, top: 0, fontSize: 13, width: 670 }}>
                        <div className="no-print">
                            <CheckboxField form={hideForm} attr="hideMedicalNote" checkboxLabel="備考を非表示" />
                        </div>
                    </div>
                )}
                <div
                    style={{
                        position: 'absolute',
                        left: 0,
                        top: isHomeTest ? '3mm' : '19mm', //リモートと医療で資材が異なる
                        width: '10cm',
                        height: '5cm',
                        paddingTop: 50,
                        paddingLeft: isHomeTest ? 30 : 80, //リモートと医療で資材が異なる
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <div>
                        {isHomeTest || props.isResultSendToPatient ? (
                            // リモートの場合または、patientに送る場合はpatientの住所を表示
                            <div style={{ fontSize: 14 }}>
                                <div>{patientVm?.addressVm().wholeView({ isBuildingLineBreak: true, zipCodeSize: 14, maxWidth: ENVELOPE_ADDRESS_WINDOW_MAX_WIDTH })}</div>
                                <div>{patientVm.fullName()} 様</div>
                            </div>
                        ) : (
                            <div style={{ fontSize: 14 }}>
                                <div>{institution?.addressVm().wholeView({ isBuildingLineBreak: true, zipCodeSize: 14, maxWidth: ENVELOPE_ADDRESS_WINDOW_MAX_WIDTH })}</div>
                                <div>
                                    <div>{institution.object.name}</div>
                                    <div>御中</div>
                                </div>
                            </div>
                        )}

                        <Barcode textPosition="top" value={props.sample.code!} width={1.0} height={30} fontSize={10} />
                    </div>
                </div>

                <div style={{ position: 'absolute', right: 87, top: 73 }}>
                    <Flex alignItems="center" style={{ marginBottom: 19 }}>
                        <div style={{ fontSize: 17, width: 229, borderBottom: 'solid 1px' }}>{patientVm.fullNameKana()}</div>
                        <div style={{ fontSize: 14 }}>様</div>
                    </Flex>
                    <Flex alignItems="center" style={{ marginBottom: 10 }}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <div style={{ fontSize: 10 }}>年齢</div>
                            <div style={{ fontSize: 11, width: 35, borderBottom: 'solid 1px' }}>
                                <div style={{ marginLeft: 5 }}>{props.sample.background?.age}</div>
                            </div>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', marginLeft: 5 }}>
                            <div style={{ fontSize: 10 }}>性別</div>
                            <div style={{ fontSize: 11, width: 35, borderBottom: 'solid 1px' }}>
                                <div style={{ marginLeft: 5 }}>{patientVm.gender()}</div>
                            </div>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', marginLeft: 5 }}>
                            <div style={{ fontSize: 10 }}>検査受付日</div>
                            <div style={{ fontSize: 11, width: 67, borderBottom: 'solid 1px' }}>
                                <div style={{ marginLeft: 5 }}>{toDateText(props.sample.inspectionDate)}</div>
                            </div>
                        </div>
                    </Flex>
                </div>
                <div
                    style={{
                        position: 'absolute',
                        right: isHomeTest ? 60 : 46, //リモートと医療で資材が異なる
                        top: 160,
                        fontSize: 17,
                        padding: 10,
                        width: 310,
                        height: 120,
                        border: 'solid 1px',
                        display: 'flex',
                        alignItems: 'center',
                    }}
                >
                    <Flex>
                        <div>
                            <div style={{ fontSize: 12, marginBottom: 10 }}>マイページからもご確認いただけます。</div>
                            <div style={{ fontSize: 12 }}>初回ログインID（受検番号）</div>
                            <div style={{ fontSize: 14, borderBottom: 'solid 1px', width: 148 }}>{props.sample.code}</div>
                        </div>
                        <Flex alignItems="center" flexDirection="column">
                            <QRCode value={`https://misignal.jp/login/${isHomeTest ? 'remote' : 'medical'}`} size={50}></QRCode>
                            <div style={{ fontSize: 10 }}>マイページQR</div>
                        </Flex>
                    </Flex>
                </div>
            </div>
        </A4>
    )
}

export const ResultSummary = (props: { sample: Sample; results: Result[]; symptoms: Symptom[]; productItems: ProductItem[] }) => {
    const patientVm = new PatientViewModel(props.sample.patient!)
    const institution = props.sample.institution

    const itemView = (topPosition: number, cancer?: string, riskLevel?: RiskLevel, symptoms?: boolean) => {
        return (
            <div style={{ position: 'absolute', left: 74, top: 378 + topPosition, fontSize: 11, width: 646, height: 35 }}>
                <div style={{ width: '100%', height: '100%', position: 'relative' }}>
                    <div style={{ position: 'absolute', top: 5, left: 10, fontSize: 17, fontWeight: 'bold' }}>{cancer ? cancer : '-'}</div>
                    <div style={{ position: 'absolute', top: 5, left: 158 }}>
                        {riskLevel === '低' ? (
                            <div style={{ width: 20, height: 20, borderRadius: 20, backgroundColor: 'black', marginTop: 3 }}></div>
                        ) : (
                            <div style={{ fontSize: 17, fontWeight: 'bold', marginLeft: 5 }}>{!cancer && '-'}</div>
                        )}
                    </div>
                    <div style={{ position: 'absolute', top: 5, left: 293 }}>
                        {riskLevel === '中' ? (
                            <div style={{ width: 20, height: 20, borderRadius: 20, backgroundColor: 'black', marginTop: 3 }}></div>
                        ) : (
                            <div style={{ fontSize: 17, fontWeight: 'bold', marginLeft: 5 }}>{!cancer && '-'}</div>
                        )}
                    </div>
                    <div style={{ position: 'absolute', top: 5, left: 425 }}>
                        {riskLevel === '高' ? (
                            <div style={{ width: 20, height: 20, borderRadius: 20, backgroundColor: 'black', marginTop: 3 }}></div>
                        ) : (
                            <div style={{ fontSize: 17, fontWeight: 'bold', marginLeft: 5 }}>{!cancer && '-'}</div>
                        )}
                    </div>
                    <div style={{ position: 'absolute', top: 5, left: 512, fontSize: 17, fontWeight: 'bold', width: 117 }}>
                        <div style={{ width: '100%', textAlign: 'center' }}>{symptoms === undefined ? '-' : symptoms ? '該当あり' : '該当なし'}</div>
                    </div>
                    {cancer && !riskLevel && (
                        <>
                            <div
                                style={{
                                    position: 'absolute',
                                    top: 0,
                                    left: 107,
                                    fontSize: 17,
                                    fontWeight: 'bold',
                                    width: 525,
                                    backgroundColor: '#eee9',
                                    textAlign: 'center',
                                    lineHeight: 1.9,
                                }}
                            >
                                未受検※
                            </div>
                        </>
                    )}
                </div>
            </div>
        )
    }
    const step = 33.4
    const drawProductItems: string[] = []
    return (
        <A4 padding={0} landscape={false}>
            <div className="page-root">
                <img src={TopImage} style={{ objectFit: 'contain', width: '100%' }} />
                <div style={{ position: 'absolute', left: 130, top: 56, fontSize: 26 }}>{patientVm.fullNameKana()}</div>
                <div style={{ position: 'absolute', left: 123, top: 108, fontSize: 16 }}>{patientVm.gender()}</div>
                <div style={{ position: 'absolute', left: 252, top: 106, fontSize: 18 }}>{props.sample.background?.age}</div>
                <div style={{ position: 'absolute', left: 400, top: 106, fontSize: 18 }}>{toDateText(props.sample.inspectionDate)}</div>
                <div style={{ position: 'absolute', left: 610, top: 106, fontSize: 18 }}>{props.sample.code}</div>
                {new Array(7).fill(0).map((_, index) => {
                    const result: Result | undefined = props.results && props.results[index]
                    if (result) {
                        drawProductItems.push(result.productItem!.nameEn!)
                    }
                    const gender = props.sample.patient?.gender
                    const productItem: ProductItem | undefined = props.productItems.find(
                        (pi) => !drawProductItems.includes(pi.nameEn!) && (!pi.targetGender || pi.targetGender === gender)
                    )
                    if (!result && productItem) {
                        drawProductItems.push(productItem.nameEn!)
                    }
                    if (result) {
                        result
                        const resultVm = ResultV2ViewModelFactory.create(result, props.sample)
                        return itemView(step * index, resultVm.cancerJa, resultVm.misignalRiskLevel(), resultVm.symptomsOfCancer(props.symptoms).length > 0)
                    } else if (productItem && (!productItem.targetGender || productItem.targetGender === gender)) {
                        return itemView(step * index, productItem.name)
                    } else {
                        return itemView(step * index)
                    }
                })}

                <Flex
                    style={{
                        position: 'absolute',
                        top: 626,
                        left: 310,
                        fontSize: 14,
                        width: 525,
                        textAlign: 'center',
                        lineHeight: 1.9,
                    }}
                    alignItems="center"
                >
                    <div>※ miSignalが受検可能な医療機関一覧はこちらから</div>
                    <QRCode size={37} value={'https://bit.ly/3fv20B0'} />
                </Flex>
                <Flex
                    style={{ position: 'absolute', left: 80, top: 729, fontSize: 18, width: 640, height: 50, padding: '0 20px', fontWeight: 'bold' }}
                    alignItems="center"
                >
                    {props.results.map((result, index) => {
                        const resultVm = ResultV2ViewModelFactory.create(result, props.sample)
                        if (
                            resultVm.misignalRiskLevel() == '低' ||
                            (resultVm.misignalRiskLevel() == '中' && resultVm.symptomsOfCancer(props.symptoms).length == 0)
                        ) {
                            return
                        }
                        return <div key={'highrisk-result-' + index}>{resultVm.cancerJa}</div>
                    })}
                </Flex>

                <Flex
                    alignItems="center"
                    style={{
                        position: 'absolute',
                        left: 80,
                        top: 884,
                        fontSize: 18,
                        width: 343,
                        height: 50,
                        padding: '0 20px',
                        fontWeight: 'bold',
                    }}
                >
                    {(() => {
                        const minMonth = Math.min(
                            ...props.results.map((result) => ResultV2ViewModelFactory.create(result, props.sample).getNextExamMonth(props.symptoms))
                        )
                        const nextMonth = moment(props.sample.inspectionDate).add('M', minMonth)
                        return <div>{nextMonth.format('YYYY年M月')}</div>
                    })()}
                </Flex>
                <Flex style={{ position: 'absolute', left: 200, bottom: 50, fontSize: 11 }}>
                    <div>検査・測定年月日:</div>
                    <div>{moment().format('YYYY年MM月DD日')}</div>
                </Flex>
                <Flex style={{ position: 'absolute', left: 445, bottom: 50, fontSize: 11 }}>
                    <div>検査・測定責任者</div>
                    <div>坪井智子</div>
                </Flex>
            </div>
        </A4>
    )
}

export type Symptom = {
    key: string
    label: string
    value: number
    products: Cancer[]
}

const Image1 = (
    image: string,
    plotImage: string,
    sample: Sample,
    symptoms: Symptom[],
    resultVm?: ResultV2ViewModel,
    prevResultVm?: ResultV2ViewModel,
    prev2ResultVm?: ResultV2ViewModel
) => {
    const patientVm = new PatientViewModel(sample.patient!)
    const imageHeight = 265
    const imageWidth = 265
    const adjust = 16

    return (
        <A4 padding={0} landscape={false}>
            <div className="page-root">
                <img src={image} style={{ objectFit: 'contain', width: '100%' }} />
                {/* <div style={{ position: 'absolute', left: 130, top: 86, fontSize: 26 }}>{patientVm.fullNameKana()}</div>
                <div style={{ position: 'absolute', left: 123, top: 136, fontSize: 16 }}>{patientVm.gender()}</div>
                <div style={{ position: 'absolute', left: 252, top: 135, fontSize: 18 }}>{resultVm?.object.background?.age}</div>
                <div style={{ position: 'absolute', left: 400, top: 135, fontSize: 18 }}>{toDateText(sample.deliveryDate)}</div>
                <div style={{ position: 'absolute', left: 610, top: 135, fontSize: 18 }}>{sample.code}</div> */}

                <div
                    style={{
                        position: 'absolute',
                        left: 100,
                        top: 378,
                        fontSize: 48,
                        width: 108,
                        textAlign: 'center',
                        color:
                            sample.resultStatus === 'NG'
                                ? 'black'
                                : resultVm?.misignalRiskLevel() === '高'
                                ? '#CF62A0'
                                : resultVm?.misignalRiskLevel() === '中'
                                ? '#776BAE'
                                : '#3D6FB7',
                    }}
                >
                    {sample.resultStatus === 'NG' ? 'N/A' : resultVm?.misignalRiskLevel()}
                </div>
                <div
                    style={{
                        position: 'absolute',
                        left: 97,
                        top: 482,
                        fontSize: 14,
                        width: 255,
                    }}
                >
                    {sample.resultStatus === 'NG' ? resultVm?.ngReasonView(sample) : resultVm?.misignalScoreSummary()}
                </div>

                {/* <div style={{ position: 'absolute', left: 81, top: 480, fontSize: 12, width: 213, textAlign: 'center' }}>
                    ({toDateText(resultVm.object.createdAt)})
                </div> */}
                {/* <div style={{ position: 'absolute', left: 81, top: 496, fontSize: 43, fontWeight: 'bold', width: 213, textAlign: 'center' }}>
                    {resultVm.misignalScore()}
                </div> */}
                {/* <div style={{ position: 'absolute', left: 155, top: 582, fontSize: 10, display: 'flex', alignItems: 'center' }}>
                    {prevResultVm && <span>({toDateText(prevResultVm?.object.createdAt)})</span>}
                    <span style={{ marginLeft: 30, fontSize: 16 }}>{prevResultVm ? prevResultVm.misignalScore() : '-'}</span>
                </div>
                <div style={{ position: 'absolute', left: 155, top: 623, fontSize: 10, display: 'flex', alignItems: 'center' }}>
                    {prev2ResultVm && <span>({toDateText(prev2ResultVm?.object.createdAt)})</span>}
                    <span style={{ marginLeft: 30, fontSize: 16 }}>{prev2ResultVm ? prev2ResultVm.misignalScore() : '-'}</span>
                </div> */}
                {sample.resultStatus !== 'NG' && (
                    <>
                        <div style={{ position: 'absolute', right: 81, top: 260, width: imageWidth, height: imageHeight }}>
                            <div style={{ position: 'absolute', top: 6, left: 6 }}>
                                <div style={{ position: 'relative', width: '100%', height: '100%' }}>
                                    <img
                                        src={resultVm?.object.plotImage?.url ?? plotImage}
                                        style={{ width: imageWidth, height: imageHeight, marginLeft: -2, marginBottom: -1, objectFit: 'fill' }}
                                    ></img>
                                    <Flex
                                        flexDirection="column"
                                        alignItems="center"
                                        style={{ position: 'absolute', bottom: -24, left: 'calc((100% * 0.5 - 5px))' }}
                                        className=""
                                    >
                                        <div style={{ height: 5, width: 1, backgroundColor: 'black', marginBottom: 3 }}></div>
                                        <div style={{ fontSize: 10 }}>50</div>
                                    </Flex>
                                    <Flex
                                        flexDirection="column"
                                        alignItems="center"
                                        style={{ position: 'absolute', bottom: -24, left: 'calc((100% * 0.75 - 5px))' }}
                                        className=""
                                    >
                                        <div style={{ height: 5, width: 1, backgroundColor: 'black', marginBottom: 3 }}></div>
                                        <div style={{ fontSize: 10 }}>75</div>
                                    </Flex>
                                    <Flex
                                        flexDirection="column"
                                        alignItems="center"
                                        style={{ position: 'absolute', bottom: -24, left: 'calc((100% * 1) - 8px)' }}
                                        className=""
                                    >
                                        <div style={{ height: 5, width: 1, backgroundColor: 'black', marginBottom: 3 }}></div>
                                        <div style={{ fontSize: 10 }}>100</div>
                                    </Flex>
                                    <Flex
                                        alignItems="center"
                                        style={{ position: 'absolute', left: -23, bottom: 'calc(((100%) * 0.5) - 8px' }}
                                        className=""
                                        justifyContent="flex-end"
                                    >
                                        <div style={{ fontSize: 10, width: 16 }}>50</div>
                                        <div style={{ width: 5, height: 1, backgroundColor: 'black' }}></div>
                                    </Flex>
                                    <Flex
                                        alignItems="center"
                                        style={{ position: 'absolute', left: -23, bottom: 'calc((100% * 0.75) - 8px' }}
                                        className=""
                                        justifyContent="flex-end"
                                    >
                                        <div style={{ fontSize: 10, width: 16 }}>75</div>
                                        <div style={{ height: 1, width: 5, backgroundColor: 'black' }}></div>
                                    </Flex>
                                    <Flex
                                        alignItems="center"
                                        style={{ position: 'absolute', left: -23, bottom: 'calc((100% * 1) - 8px' }}
                                        className=""
                                        justifyContent="flex-end"
                                    >
                                        <div style={{ fontSize: 10, width: 16 }}>100</div>
                                        <div style={{ height: 1, width: 5, backgroundColor: 'black' }}></div>
                                    </Flex>
                                </div>
                            </div>
                            <div style={{ position: 'relative', height: '100%', width: '100%', marginLeft: 3 }}>
                                <div style={{ fontSize: 52, color: '#fff8', position: 'absolute', ...resultVm?.getLowTextPosition() }}>低</div>
                                <div style={{ fontSize: 52, color: '#fff8', position: 'absolute', ...resultVm?.getMiddleTextPosition() }}>中</div>
                                <div style={{ fontSize: 52, color: '#fff8', position: 'absolute', ...resultVm?.getHighTextPosition() }}>高</div>
                                {/* {prev2ResultVm && (
                                    <Previous2
                                        style={{
                                            position: 'absolute',
                                            bottom: `calc((100% - 10px) * ${prev2ResultVm.info().plot.y} / 100)`,
                                            left: `calc((100% - 5px) * ${prev2ResultVm.info().plot.x} / 100)`,
                                        }}
                                        originCenter
                                    ></Previous2>
                                )}
                                {prevResultVm && (
                                    <Previous
                                        style={{
                                            position: 'absolute',
                                            bottom: `calc((100% - 10px) * ${prevResultVm.info().plot.y} / 100)`,
                                            left: `calc((100% - 5px) * ${prevResultVm.info().plot.x} / 100)`,
                                        }}
                                        originCenter
                                    ></Previous>
                                )} */}
                                {/* <SomeGeneration
                            style={{
                                position: 'absolute',
                                bottom: (imageHeight * resultVm.info()!.standard_y) / 100,
                                left: (imageWidth * resultVm.info()!.standard_x) / 100,
                            }}
                        ></SomeGeneration> */}
                                <Current
                                    style={{
                                        position: 'absolute',
                                        bottom: `calc((263px * ${resultVm?.info().plot.y} / 100) - 6px)`,
                                        left: `calc((264px * ${resultVm?.info().plot.x} / 100) - 5px)`,
                                    }}
                                    originCenter
                                ></Current>
                            </div>
                        </div>
                        <div style={{ position: 'absolute', width: 280, top: 246, right: 80, fontSize: 11 }}>
                            <Flex justifyContent="flex-end" style={{ width: '100%' }}>
                                <Flex className="">
                                    <td style={{ verticalAlign: 'top', paddingTop: 5, paddingRight: 5, paddingLeft: 2 }}>
                                        <Current style={{ width: 8, height: 8 }}></Current>
                                    </td>
                                    <td>
                                        <div style={{ marginBottom: 8 }}>今回の結果 {toDateText(resultVm?.object.createdAt)}</div>
                                    </td>
                                </Flex>
                                {/* <tr>
                                <td style={{ verticalAlign: 'top', paddingTop: 5, paddingRight: 5, paddingLeft: 2 }}>
                                    <SomeGeneration></SomeGeneration>
                                </td>
                                <td>
                                    <div style={{ marginBottom: 8 }}>同世代の標準</div>
                                </td>
                            </tr> */}
                                {/* {prevResultVm && (
                                    <Flex className="">
                                        <td style={{ verticalAlign: 'top', paddingTop: 5, paddingRight: 5, paddingLeft: 2 }}>
                                            <Previous style={{ width: 8, height: 8 }}></Previous>
                                        </td>
                                        <td>
                                            <div style={{ marginBottom: 8 }}>
                                                前回の結果
                                                <div style={{ fontSize: 10 }}>({toDateText(prevResultVm.object.createdAt)})</div>
                                            </div>
                                        </td>
                                    </Flex>
                                )}
                                {prev2ResultVm && (
                                    <Flex className="">
                                        <td style={{ verticalAlign: 'top', paddingTop: 5, paddingRight: 5 }}>
                                            <Previous2 style={{ width: 8, height: 8 }}></Previous2>
                                        </td>
                                        <td>
                                            <div style={{ marginBottom: 8 }}>
                                                前々回の結果
                                                <div style={{ fontSize: 10 }}>({toDateText(prev2ResultVm.object.createdAt)})</div>
                                            </div>
                                        </td>
                                    </Flex>
                                )} */}
                            </Flex>
                        </div>
                    </>
                )}
                {(sample.resultStatus === 'REFERENCE' || resultVm?.object.isReferenceByBiomarker) && (
                    <div style={{ position: 'absolute', left: 75, bottom: 500, width: 682 }}>
                        <div>
                            右記の理由から検査結果はあくまで参考値となります：{new SampleViewModel(sample).getReferenceReason(resultVm?.object).join('・')}
                        </div>
                    </div>
                )}
                {sample.resultStatus === 'NG' ? (
                    <div style={{ position: 'absolute', left: 78, bottom: 335, width: 639, height: 96, padding: '20px', fontSize: 32 }}>N/A</div>
                ) : (
                    <div style={{ position: 'absolute', left: 78, bottom: 335, width: 639, height: 96, padding: '10px 40px' }}>
                        {resultVm?.symptomsView(symptoms)}
                    </div>
                )}
                <div style={{ position: 'absolute', left: 49, bottom: 220, width: 644, height: 122, padding: 20, fontSize: 32 }}>
                    <div style={{ width: 650, height: 20, backgroundColor: 'white' }}>
                        <div style={{ fontSize: 10, color: '#163264' }}>
                            「低リスク」であっても、関連する症状が頻繁に出る方は、医師に相談されることをおすすめします。
                        </div>
                    </div>
                </div>
                {sample.resultStatus === 'NG' ? (
                    <div style={{ position: 'absolute', left: 76, bottom: 120, width: 644, height: 122, padding: 20, fontSize: 32 }}>N/A</div>
                ) : (
                    <div style={{ position: 'absolute', left: 76, bottom: 137, fontSize: 14, width: 644, height: 122, padding: 20 }}>
                        {resultVm?.misignalScoreComment()}
                    </div>
                )}
                <div style={{ position: 'absolute', left: 90, bottom: 85, fontSize: 11, zIndex: 100 }}>
                    ※miSignal®︎では定期的にがん判定アルゴリズムをアップデートしております。
                </div>
                <div style={{ position: 'absolute', left: 200, bottom: 78, fontSize: 11, width: 400, height: 30, backgroundColor: 'white' }}></div>
                <div style={{ position: 'absolute', right: 220, bottom: 24, fontSize: 11 }}>{patientVm.fullNameKana()}</div>
                <div style={{ position: 'absolute', left: 669, bottom: 23, fontSize: 11 }}>{sample.code}</div>
            </div>
        </A4>
    )
}

const Image2 = (image: string, sample: Sample, resultVm?: ResultV2ViewModel, prevResultVm?: ResultV2ViewModel, prev2ResultVm?: ResultV2ViewModel) => {
    const patientVm = new PatientViewModel(sample.patient!)
    const standardScore = 50
    return (
        <A4 padding={0} landscape={false}>
            <div className="page-root">
                <img src={image} style={{ objectFit: 'contain', width: '100%' }} />
                <div style={{ position: 'absolute', left: 100, top: 212, fontSize: 40, width: 120, textAlign: 'center' }}>
                    {sample.resultStatus === 'NG' ? <div>N/A</div> : resultVm?.miRnaScore()}
                </div>
                {sample.resultStatus !== 'NG' && (
                    <>
                        <div style={{ position: 'absolute', left: 245, top: 193, fontSize: 19, width: 456, height: 85, display: 'flex', alignItems: 'center' }}>
                            {resultVm?.miRnaScoreSummary(prevResultVm)}
                        </div>
                        <div style={{ position: 'absolute', left: 76, top: 302, fontSize: 13, width: 280 }}>{resultVm?.miRnaScoreComment()}</div>
                        <div style={{ position: 'absolute', right: 75, top: 296, fontSize: 11 }}>
                            <Flex alignItems="center">
                                <Flex alignItems="center">
                                    <Current style={{ width: 8, height: 8 }} />
                                    <div>今回のあなたのスコア({resultVm?.miRnaScore()})</div>
                                </Flex>
                                {/* <Flex alignItems="center">
                            <SomeGeneration style={{ width: 8, height: 8 }} />
                            <div>健康な方の標準スコア({standardScore})</div>
                        </Flex> */}
                            </Flex>
                        </div>
                        <div style={{ position: 'absolute', right: 85, top: 317, width: 347, height: 13 }}>
                            <div style={{ position: 'relative', width: '100%', height: '100%' }}>
                                <Current
                                    style={{
                                        width: 10,
                                        height: 10,
                                        position: 'absolute',
                                        top: 0,
                                        left: `calc(352px * ${(resultVm?.miRnaScore() ?? 0) / 100})`,
                                    }}
                                ></Current>
                            </div>
                        </div>
                        {/* <div style={{ position: 'absolute', right: 57, top: 345, width: 370, height: 13 }}>
                    <div style={{ position: 'relative', width: '100%', height: '100%' }}>
                        <SomeGeneration style={{ width: 10, height: 10, position: 'absolute', top: 0, left: 358 * (standardScore / 100) }}></SomeGeneration>
                    </div>
                </div> */}
                        <Flex
                            style={{ position: 'absolute', left: 370, top: 421, fontSize: 13, width: 144 }}
                            alignItems="center"
                            justifyContent="space-between"
                            className=""
                        >
                            <div>
                                <span style={{ marginRight: 3 }}>今回</span>
                                <span style={{ marginRight: 3, fontSize: 11 }}>({toDateText(resultVm?.object.createdAt)})</span>
                            </div>
                            <span style={{ fontSize: 19, lineHeight: 1, width: 30, textAlign: 'center' }}>{resultVm?.miRnaScore()}</span>
                        </Flex>
                        <Flex
                            style={{ position: 'absolute', left: 522, top: 418, fontSize: 10, width: 92 }}
                            alignItems="center"
                            justifyContent="space-between"
                            className=""
                        >
                            <div style={{ position: 'relative', height: 20 }}>
                                <div style={{ marginRight: 3 }}>前回</div>
                                <div style={{ marginRight: 3, fontSize: 11, transform: 'scale(90%)', position: 'absolute', bottom: -7, left: -4 }}>
                                    {prevResultVm?.object ? `(${toDateText(prevResultVm.object.createdAt)})` : ''}
                                </div>
                            </div>
                            <span style={{ fontSize: 16, lineHeight: 1, width: 30, textAlign: 'center' }}>
                                {prevResultVm?.object ? prevResultVm.miRnaScore() : '-'}
                            </span>
                        </Flex>
                        <Flex
                            style={{ position: 'absolute', left: 624, top: 418, fontSize: 10, width: 92 }}
                            alignItems="center"
                            justifyContent="space-between"
                            className=""
                        >
                            <div style={{ position: 'relative', height: 20 }}>
                                <div style={{ marginRight: 3 }}>前々回</div>
                                <div style={{ marginRight: 3, fontSize: 11, transform: 'scale(90%)', position: 'absolute', bottom: -7, left: -4 }}>
                                    {prev2ResultVm?.object ? `(${toDateText(prev2ResultVm.object.createdAt)})` : ''}
                                </div>
                            </div>
                            <span style={{ fontSize: 16, lineHeight: 1, width: 30, textAlign: 'center' }}>
                                {prev2ResultVm?.object ? prev2ResultVm.miRnaScore() : '-'}
                            </span>
                        </Flex>
                    </>
                )}

                <div style={{ position: 'absolute', right: 220, bottom: 24, fontSize: 11 }}>{patientVm.fullNameKana()}</div>
                <div style={{ position: 'absolute', left: 669, bottom: 23, fontSize: 11 }}>{sample.code}</div>
            </div>
        </A4>
    )
}

const Image3 = (image: string, sample: Sample, resultVm?: ResultV2ViewModel, prevResultVm?: ResultV2ViewModel, prev2ResultVm?: ResultV2ViewModel) => {
    const patientVm = new PatientViewModel(sample.patient!)
    return (
        <A4 padding={0} landscape={false}>
            <div className="page-root">
                <img src={image} style={{ objectFit: 'contain', width: '100%' }} />
                <div style={{ position: 'absolute', left: 100, top: 212, fontSize: 40, width: 120, textAlign: 'center' }}>
                    {sample.resultStatus === 'NG' ? <div>N/A</div> : resultVm?.personalScore()}
                </div>

                {sample.resultStatus !== 'NG' && (
                    <>
                        <div
                            style={{
                                position: 'absolute',
                                left: 245,
                                top: 193,
                                fontSize: 17,
                                width: 456,
                                height: 85,
                                display: 'flex',
                                alignItems: 'center',
                            }}
                        >
                            {resultVm?.personalScoreSummary()}
                        </div>
                        <div style={{ position: 'absolute', left: 76, top: 302, fontSize: 13, width: 280 }}>{resultVm?.personalScoreComment()}</div>
                        <div style={{ position: 'absolute', right: 75, top: 296, fontSize: 11 }}>
                            <Flex alignItems="center">
                                <Flex alignItems="center">
                                    <Current style={{ width: 8, height: 8 }} />
                                    <div>今回のあなたのスコア({resultVm?.personalScore()})</div>
                                </Flex>
                                {/* <Flex alignItems="center">
                            <SomeGeneration style={{ width: 8, height: 8 }} />
                            <div>健康な方の標準スコア({standardScore})</div>
                        </Flex> */}
                            </Flex>
                        </div>
                        <div style={{ position: 'absolute', right: 85, top: 317, width: 347, height: 13 }}>
                            <div style={{ position: 'relative', width: '100%', height: '100%' }}>
                                <Current
                                    style={{
                                        width: 10,
                                        height: 10,
                                        position: 'absolute',
                                        top: 0,
                                        left: `calc(352px * ${(resultVm?.personalScore() ?? 0) / 100})`,
                                    }}
                                ></Current>
                            </div>
                        </div>
                        {/* <div style={{ position: 'absolute', right: 57, top: 345, width: 370, height: 13 }}>
                    <div style={{ position: 'relative', width: '100%', height: '100%' }}>
                        <SomeGeneration style={{ width: 10, height: 10, position: 'absolute', top: 0, left: 358 * (standardScore / 100) }}></SomeGeneration>
                    </div>
                </div> */}
                        <Flex
                            style={{ position: 'absolute', left: 370, top: 421, fontSize: 13, width: 144 }}
                            alignItems="center"
                            justifyContent="space-between"
                            className=""
                        >
                            <div>
                                <span style={{ marginRight: 3 }}>今回</span>
                                <span style={{ marginRight: 3, fontSize: 11 }}>({toDateText(resultVm?.object.createdAt)})</span>
                            </div>
                            <span style={{ fontSize: 20, lineHeight: 1, width: 30, textAlign: 'center' }}>{resultVm?.personalScore()}</span>
                        </Flex>
                        <Flex
                            style={{ position: 'absolute', left: 522, top: 418, fontSize: 10, width: 92 }}
                            alignItems="center"
                            justifyContent="space-between"
                            className=""
                        >
                            <div style={{ position: 'relative', height: 20 }}>
                                <div style={{ marginRight: 3 }}>前回</div>
                                <div style={{ marginRight: 3, fontSize: 11, transform: 'scale(90%)', position: 'absolute', bottom: -7, left: -4 }}>
                                    {prevResultVm?.object ? `(${toDateText(prevResultVm?.object.createdAt)})` : ''}
                                </div>
                            </div>
                            <span style={{ fontSize: 16, lineHeight: 1, width: 30, textAlign: 'center' }}>
                                {prevResultVm?.object ? prevResultVm.personalScore() : '-'}
                            </span>
                        </Flex>
                        <Flex
                            style={{ position: 'absolute', left: 624, top: 418, fontSize: 10, width: 92 }}
                            alignItems="center"
                            justifyContent="space-between"
                            className=""
                        >
                            <div style={{ position: 'relative', height: 20 }}>
                                <div style={{ marginRight: 3 }}>前々回</div>
                                <div style={{ marginRight: 3, fontSize: 11, transform: 'scale(90%)', position: 'absolute', bottom: -7, left: -4 }}>
                                    {prev2ResultVm?.object ? `(${toDateText(prev2ResultVm.object.createdAt)})` : ''}
                                </div>
                            </div>
                            <span style={{ fontSize: 16, lineHeight: 1, width: 30, textAlign: 'center' }}>
                                {prev2ResultVm?.object ? `${prev2ResultVm?.personalScore()}` : '-'}
                            </span>
                        </Flex>
                        {(() => {
                            if (resultVm?.object.productItem?.nameEn === 'ovary') {
                                const vm = resultVm as OvaryResultV2ViewModel
                                const riskScore = vm.info().risk_score
                                const riskRatio = vm.info().risk_ratio
                                const riskData = vm.info().risk_data
                                let position = 508
                                const section = 52.1
                                const keys: (keyof OvaryRiskScore)[] = [
                                    'age',
                                    'height',
                                    'BMI',
                                    'birth_count',
                                    'pill',
                                    'endometriosis',
                                    'breast_cancer',
                                    'family',
                                ]
                                return (
                                    <div key="ovary">
                                        {keys.map((key, index) => {
                                            return (
                                                <>
                                                    <PersonalRiskView
                                                        answer={eval(`vm.${key}()`)}
                                                        risk={riskScore[key]}
                                                        ratio={riskRatio[key]}
                                                        viewPosition={position}
                                                        riskDataItem={riskData[key]}
                                                        {...{
                                                            markerSize: 8,
                                                            riskPosition: 92,
                                                            plotPosition: 241,
                                                            labelWidth: 80,
                                                            commentWidth: 194,
                                                        }}
                                                    />
                                                    {(position += section)}
                                                </>
                                            )
                                        })}
                                    </div>
                                )
                            }
                        })()}
                        {(() => {
                            if (resultVm?.object.productItem?.nameEn === 'breast') {
                                const vm = resultVm as BreastResultV2ViewModel
                                const riskScore = vm.info().risk_score
                                const riskRatio = vm.info().risk_ratio
                                const riskData = vm.info().risk_data
                                let position = 503
                                const section = 41.7

                                const keys: (keyof BreastRiskScore)[] = [
                                    'age',
                                    'BMI',
                                    'smoking',
                                    'alcohol',
                                    'exercise',
                                    'breast_family_history',
                                    'diabetes',
                                    'age_at_first_birth',
                                    'birth_count',
                                    'mammography',
                                ]
                                return (
                                    <div key="breast">
                                        {keys.map((key) => {
                                            return (
                                                <>
                                                    <PersonalRiskView
                                                        answer={eval(`vm.${key}()`)}
                                                        risk={riskScore[key]}
                                                        ratio={riskRatio[key]}
                                                        viewPosition={position}
                                                        riskDataItem={riskData[key]}
                                                        {...{
                                                            markerSize: 8,
                                                            riskPosition: 101,
                                                            plotPosition: 255,
                                                            labelWidth: 73,
                                                            commentWidth: 177,
                                                        }}
                                                    />
                                                    {(position += section)}
                                                </>
                                            )
                                        })}
                                    </div>
                                )
                            }
                        })()}
                        {(() => {
                            if (resultVm?.object.productItem?.nameEn === 'stomach') {
                                const vm = resultVm as StomachResultV2ViewModel
                                const riskScore = vm.info().risk_score
                                const riskRatio = vm.info().risk_ratio
                                const riskData = vm.info().risk_data
                                let position = 519
                                const section = 58.4

                                const keys: (keyof StomachRiskScore)[] = [
                                    'age',
                                    'stomach_family_history',
                                    'helicobacter',
                                    'chronic_gastritis',
                                    'gastric_ulcer',
                                    'smoking',
                                    'eating_habits_of_salted_food',
                                ]
                                return (
                                    <div key="stomach">
                                        {keys.map((key) => {
                                            return (
                                                <>
                                                    <PersonalRiskView
                                                        answer={eval(`vm.${key}()`)}
                                                        risk={riskScore[key]}
                                                        ratio={riskRatio[key]}
                                                        viewPosition={position}
                                                        riskDataItem={riskData[key]}
                                                        {...{
                                                            markerSize: 8,
                                                            riskPosition: 92,
                                                            plotPosition: 241,
                                                            labelWidth: 80,
                                                            commentWidth: 194,
                                                        }}
                                                    />
                                                    {(position += section)}
                                                </>
                                            )
                                        })}
                                    </div>
                                )
                            }
                        })()}
                        {(() => {
                            if (resultVm?.object.productItem?.nameEn === 'lung') {
                                const vm = resultVm as LungResultV2ViewModel
                                const riskScore = vm.info().risk_score
                                const riskRatio = vm.info().risk_ratio
                                const riskData = vm.info().risk_data
                                let position = 508
                                const section = 52

                                const keys: (keyof LungRiskScore)[] = [
                                    'age',
                                    'smoking',
                                    'family_smoking',
                                    'COPD',
                                    'pneumonia',
                                    'tuberculosis',
                                    'BMI',
                                    'lung_family_history',
                                ]
                                return (
                                    <div key="lung">
                                        {keys.map((key) => {
                                            return (
                                                <>
                                                    <PersonalRiskView
                                                        answer={eval(`vm.${key}()`)}
                                                        risk={riskScore[key]}
                                                        ratio={riskRatio[key]}
                                                        viewPosition={position}
                                                        riskDataItem={riskData[key]}
                                                        {...{
                                                            markerSize: 8,
                                                            riskPosition: 92,
                                                            plotPosition: 241,
                                                            labelWidth: 80,
                                                            commentWidth: 194,
                                                        }}
                                                    />
                                                    {(position += section)}
                                                </>
                                            )
                                        })}
                                    </div>
                                )
                            }
                        })()}

                        {(() => {
                            if (resultVm?.object.productItem?.nameEn === 'esophagus') {
                                const vm = resultVm as EsophagusResultV2ViewModel
                                const riskScore = vm.info().risk_score
                                const riskRatio = vm.info().risk_ratio
                                const riskData = vm.info().risk_data
                                let position = 548
                                const section = 70.4

                                const keys: (keyof EsophagusRiskScore)[] = [
                                    'age',
                                    'esophagus_family_history',
                                    'smoking',
                                    'alcohol',
                                    'eating_habits_of_vegetables_and_fruits',
                                ]
                                return (
                                    <div key="esophagus">
                                        {keys.map((key) => {
                                            return (
                                                <>
                                                    <PersonalRiskView
                                                        answer={eval(`vm.${key}()`)}
                                                        risk={riskScore[key]}
                                                        ratio={riskRatio[key]}
                                                        viewPosition={position}
                                                        riskDataItem={riskData[key]}
                                                        {...{
                                                            markerSize: 8,
                                                            riskPosition: 92,
                                                            plotPosition: 241,
                                                            labelWidth: 80,
                                                            commentWidth: 194,
                                                        }}
                                                    />
                                                    {(position += section)}
                                                </>
                                            )
                                        })}
                                    </div>
                                )
                            }
                        })()}
                        {(() => {
                            if (resultVm?.object.productItem?.nameEn === 'colorectal') {
                                const vm = resultVm as ColorectalResultV2ViewModel
                                const riskScore = vm.info().risk_score
                                const riskRatio = vm.info().risk_ratio
                                const riskData = vm.info().risk_data
                                let position = 519
                                const section = 58.3

                                const keys: (keyof ColorectalRiskScore)[] = [
                                    'age',
                                    'colorectal_family_history',
                                    'ulcerative_colitis',
                                    'smoking',
                                    'alcohol',
                                    'exercise',
                                    'BMI',
                                ]
                                return (
                                    <div key="colorectal">
                                        {keys.map((key) => {
                                            return (
                                                <>
                                                    <PersonalRiskView
                                                        answer={eval(`vm.${key}()`)}
                                                        risk={riskScore[key]}
                                                        ratio={riskRatio[key]}
                                                        viewPosition={position}
                                                        riskDataItem={riskData[key]}
                                                        {...{
                                                            markerSize: 8,
                                                            riskPosition: 92,
                                                            plotPosition: 241,
                                                            labelWidth: 80,
                                                            commentWidth: 194,
                                                        }}
                                                    />
                                                    {(position += section)}
                                                </>
                                            )
                                        })}
                                    </div>
                                )
                            }
                        })()}
                        {(() => {
                            if (resultVm?.object.productItem?.nameEn === 'pancreas') {
                                const vm = resultVm as PancreasResultV2ViewModel
                                const riskScore = vm.info().risk_score
                                const riskRatio = vm.info().risk_ratio
                                const riskData = vm.info().risk_data
                                let position = 519
                                const section = 58.3

                                const keys: (keyof PancreasRiskScore)[] = [
                                    'age',
                                    'blood_type',
                                    'pancreas_family_history',
                                    'disease',
                                    'smoking',
                                    'alcohol',
                                    'BMI',
                                ]
                                return (
                                    <div key="pancreas">
                                        {keys.map((key) => {
                                            return (
                                                <>
                                                    <PersonalRiskView
                                                        answer={eval(`vm.${key}()`)}
                                                        risk={riskScore[key]}
                                                        ratio={riskRatio[key]}
                                                        viewPosition={position}
                                                        riskDataItem={riskData[key]}
                                                        {...{
                                                            markerSize: 8,
                                                            riskPosition: 92,
                                                            plotPosition: 241,
                                                            labelWidth: 80,
                                                            commentWidth: 194,
                                                        }}
                                                    />
                                                    {(position += section)}
                                                </>
                                            )
                                        })}
                                    </div>
                                )
                            }
                        })()}
                    </>
                )}
                <div style={{ position: 'absolute', right: 220, bottom: 24, fontSize: 11 }}>{patientVm.fullNameKana()}</div>
                <div style={{ position: 'absolute', left: 669, bottom: 23, fontSize: 11 }}>{sample.code}</div>
            </div>
        </A4>
    )
}

const Image4 = (image: string, sample: Sample, symptoms: Symptom[], resultVm?: ResultV2ViewModel) => {
    const patientVm = new PatientViewModel(sample.patient!)
    const hasSymptom = !!resultVm?.symptomsOfCancer(symptoms).length || false
    let mdAllowHeight = 0
    let lgAllowHeight = 0
    if (resultVm?.object.productItem?.nameEn === 'ovary') {
        mdAllowHeight = 214
        lgAllowHeight = 475
    } else if (resultVm?.object.productItem?.nameEn === 'breast') {
        mdAllowHeight = 214
        lgAllowHeight = 476
    } else if (resultVm?.object.productItem?.nameEn === 'lung') {
        mdAllowHeight = 110
        lgAllowHeight = 370
    } else if (resultVm?.object.productItem?.nameEn === 'stomach') {
        mdAllowHeight = 127
        lgAllowHeight = 387
    } else if (resultVm?.object.productItem?.nameEn === 'colorectal') {
        mdAllowHeight = 90
        lgAllowHeight = 350
    } else if (resultVm?.object.productItem?.nameEn === 'esophagus') {
        mdAllowHeight = 90
        lgAllowHeight = 350
    } else if (resultVm?.object.productItem?.nameEn === 'pancreas') {
        mdAllowHeight = 90
        lgAllowHeight = 350
    }
    return (
        <A4 padding={0} landscape={false}>
            <div className="page-root">
                <img src={image} style={{ objectFit: 'contain', width: '100%' }} />
                {sample.resultStatus === 'NG' ? (
                    <div style={{ fontSize: 50, position: 'absolute', top: 220, left: 100 }}>N/A</div>
                ) : (
                    <>
                        <Flex
                            style={{ position: 'absolute', left: 55, top: 205, fontSize: 24, width: 685, height: 100, textAlign: 'center' }}
                            className="child-margin-r-25"
                        >
                            <RiskPanelView misignalRiskLevelText="高" currentRiskLevel={resultVm?.misignalRiskLevel()} hideSymptom />
                            <RiskPanelView misignalRiskLevelText="中" currentRiskLevel={resultVm?.misignalRiskLevel()} hasSymptom={hasSymptom} />
                            <RiskPanelView misignalRiskLevelText="低" currentRiskLevel={resultVm?.misignalRiskLevel()} hasSymptom={hasSymptom} />
                        </Flex>

                        {/* 高リスク矢印 */}
                        <div style={{ position: 'absolute', left: 155, top: 308 }}>
                            <Arrow height={30} arrowSize={6} primary={resultVm?.misignalRiskLevel() === '高'} />
                        </div>

                        {/* 中リスク矢印 */}
                        <div style={{ position: 'absolute', left: 350, top: 308 }}>
                            <Arrow height={30} arrowSize={6} primary={resultVm?.misignalRiskLevel() === '中' && hasSymptom} />
                        </div>

                        <div style={{ position: 'absolute', left: 436, top: 308 }}>
                            <Arrow height={240} arrowSize={6} hideTriangle primary={resultVm?.misignalRiskLevel() === '中' && !hasSymptom} />
                        </div>
                        <div style={{ position: 'absolute', left: 436, top: 568 }}>
                            <Arrow height={mdAllowHeight} arrowSize={6} primary={resultVm?.misignalRiskLevel() === '中' && !hasSymptom} />
                        </div>

                        {/* 低リスク矢印 */}
                        <div style={{ position: 'absolute', left: 586, top: 308 }}>
                            <Arrow height={30} arrowSize={6} primary={resultVm?.misignalRiskLevel() === '低' && hasSymptom} />
                        </div>
                        <div style={{ position: 'absolute', left: 672, top: 308 }}>
                            <Arrow height={lgAllowHeight} arrowSize={6} primary={resultVm?.misignalRiskLevel() === '低' && !hasSymptom} />
                        </div>
                    </>
                )}
                <div style={{ position: 'absolute', right: 220, bottom: 24, fontSize: 11 }}>{patientVm.fullNameKana()}</div>
                <div style={{ position: 'absolute', left: 669, bottom: 23, fontSize: 11 }}>{sample.code}</div>
                <div style={{ position: 'absolute', right: 220, bottom: 24, fontSize: 11 }}>{patientVm.fullNameKana()}</div>
                <div style={{ position: 'absolute', left: 669, bottom: 23, fontSize: 11 }}>{sample.code}</div>
            </div>
        </A4>
    )
}

const Arrow = (props: { height: number; arrowSize: number; hideTriangle?: boolean; primary?: boolean }) => {
    const color = props.primary ? '#1A3164' : '#777'
    return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: 10, height: props.height }}>
            <div style={{ flexGrow: 1, width: 2, backgroundColor: color }}></div>
            {!props.hideTriangle && (
                <div
                    style={{
                        borderRight: `${props.arrowSize}px solid transparent`,
                        borderTop: `${(Math.sqrt(3) / 2) * props.arrowSize * 2}px solid ${color}`,
                        borderLeft: `${props.arrowSize}px solid transparent`,
                    }}
                ></div>
            )}
        </div>
    )
}
const RiskPanelView = (props: { misignalRiskLevelText: RiskLevel; currentRiskLevel?: RiskLevel; hasSymptom?: boolean; hideSymptom?: boolean }) => {
    const panelStyle = () => {
        if (props.misignalRiskLevelText === props.currentRiskLevel) {
            if (props.misignalRiskLevelText === '高') {
                return { backgroundColor: '#1A3164', color: 'white' }
            } else if (props.misignalRiskLevelText === '中') {
                return { backgroundColor: '#776BAE', color: 'white' }
            } else {
                return { backgroundColor: '#3D6FB7', color: 'white' }
            }
        }
        return { backgroundColor: '#DCDCDC', color: 'black' }
    }

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                fontSize: 24,
                width: '100%',
                height: '100%',
                textAlign: 'center',
                borderRadius: 5,
                ...panelStyle(),
            }}
        >
            <Flex style={{ flexGrow: 1 }} alignItems="center">
                <Flex className="" alignItems="flex-end">
                    {props.misignalRiskLevelText}
                    <span style={{ fontSize: 18, marginBottom: 2 }}>リスク</span>
                </Flex>
            </Flex>
            {!props.hideSymptom && (
                <Flex style={{ height: 40, fontSize: 13, color: 'black' }} className="child-margin-r-15">
                    <div
                        style={{
                            padding: '2px 10px',
                            borderRadius: 3,
                            textAlign: 'center',
                            ...(props.hasSymptom === true && props.currentRiskLevel === props.misignalRiskLevelText
                                ? { backgroundColor: '#1A3164', color: 'white' }
                                : { backgroundColor: 'white' }),
                        }}
                    >
                        症状有り
                    </div>
                    <div
                        style={{
                            padding: '2px 10px',
                            borderRadius: 3,
                            textAlign: 'center',
                            ...(props.hasSymptom === false && props.currentRiskLevel === props.misignalRiskLevelText
                                ? { backgroundColor: '#1A3164', color: 'white' }
                                : { backgroundColor: 'white' }),
                        }}
                    >
                        症状無し
                    </div>
                </Flex>
            )}
        </div>
    )
}
const PersonalRiskView = (props: {
    answer: string
    risk: number
    viewPosition: number
    ratio: number
    riskPosition: number
    plotPosition: number
    markerSize: number
    riskDataItem: RiskDataItem
    labelWidth: number
    commentWidth: number
}) => {
    const fixNumber = (num: number, label: string) => {
        if (num < 0.1) {
            return '0.1倍以下'
        }
        if (String(num).length === 1 || label === '年齢') {
            return num.toFixed(1) + '倍'
        } else {
            const n = ceil(num, 2).toFixed(2)
            if (n[n.length - 1] === '0') {
                return n.slice(0, n.length - 1) + '倍'
            } else {
                return n + '倍'
            }
        }
    }

    const convertLabel = (label: string) => {
        const list = [
            '乳がんの既往歴',
            '乳がんの家族歴',
            '糖尿病の既往歴',
            '初めての妊娠の年齢',
            '同居家族の喫煙',
            '肺がんの家族歴',
            '胃がんの家族歴',
            '慢性胃炎の既往歴',
            '胃潰瘍の既往歴',
            '塩蔵品の食習慣',
            'すい臓がんの家族歴',
            '大腸がんの家族歴',
            '食道がんの家族歴',
            '野菜・果物の食習慣',
        ]
        if (list.includes(label)) {
            const split = label.split('の')
            const other = split.slice(1)
            return (
                <>
                    <div>{split[0]}の</div>
                    <div>{other.join('の')}</div>
                </>
            )
        }
        return <>{label}</>
    }

    return (
        <div>
            <div style={{ position: 'absolute', left: 170, top: props.viewPosition, fontSize: 10, width: 345, height: 53 }}>
                <div
                    style={{
                        position: 'absolute',
                        left: -80,
                        top: 15,
                        fontSize: 13,
                        width: props.labelWidth,
                        height: 25,
                        display: 'flex',
                        alignItems: 'center',
                        lineHeight: 1.3,
                    }}
                >
                    <div>{convertLabel(props.riskDataItem.label)}</div>
                </div>
                <div
                    style={{
                        position: 'absolute',
                        left: 13,
                        top: 18,
                        fontSize: 12,
                        width: 73,
                        height: 25,
                        textAlign: 'center',
                    }}
                >
                    {props.answer}
                </div>
                <div
                    style={{
                        position: 'absolute',
                        left: props.riskPosition,
                        top: 19,
                        fontSize: 13,
                        width: 67,
                        height: 25,
                        textAlign: 'center',
                    }}
                >
                    {fixNumber(props.risk, props.riskDataItem.label)}
                </div>
                <div style={{ position: 'absolute', left: props.plotPosition, bottom: 6, fontSize: 10, width: 70, height: 15 }}>
                    <div style={{ position: 'relative', width: '100%', height: '100%' }}>
                        <Current style={{ width: props.markerSize, height: props.markerSize, position: 'absolute', top: 2, left: 70 * props.ratio }} />
                    </div>
                </div>
                <div style={{ position: 'absolute', left: props.plotPosition - 73, bottom: 19, fontSize: 10, width: 153, height: 22 }}>
                    <Flex style={{ position: 'relative', width: '100%', height: '100%' }} justifyContent="space-between" className="">
                        <Flex alignItems="flex-start" flexDirection="column" className="" style={{ width: '33%' }}>
                            {props.riskDataItem.text.min ? (
                                <>
                                    <div style={{ transform: 'scale(70%)', lineHeight: 0.5, transformOrigin: 'left', whiteSpace: 'nowrap' }}>
                                        {props.riskDataItem.text.min}
                                    </div>
                                    <div>{fixNumber(Math.min(...Object.values(props.riskDataItem.rates)), props.riskDataItem.label)}</div>
                                </>
                            ) : (
                                <div style={{ width: '100%' }}></div>
                            )}
                        </Flex>
                        <Flex alignItems="center" flexDirection="column" className="" style={{ width: '33%' }}>
                            {props.riskDataItem.text.mid && (
                                <>
                                    <div style={{ transform: 'scale(70%)', lineHeight: 0.5, whiteSpace: 'nowrap' }}>{props.riskDataItem.text.mid}</div>
                                    <div>1.0倍</div>
                                </>
                            )}
                        </Flex>
                        <Flex alignItems="flex-end" flexDirection="column" className="" style={{ width: '33%' }}>
                            {props.riskDataItem.text.max && (
                                <>
                                    <div style={{ transform: 'scale(70%)', lineHeight: 0.5, transformOrigin: 'right', whiteSpace: 'nowrap' }}>
                                        {props.riskDataItem.text.max}
                                    </div>
                                    <div>{fixNumber(Math.max(...Object.values(props.riskDataItem.rates)), props.riskDataItem.label)}</div>
                                </>
                            )}
                        </Flex>
                    </Flex>
                </div>
                <div
                    style={{
                        position: 'absolute',
                        left: props.plotPosition + 98,
                        bottom: 10,
                        fontSize: 10,
                        width: props.commentWidth,
                        height: 32,
                        lineHeight: 1.2,
                        display: 'flex',
                        alignItems: 'center',
                    }}
                >
                    <div style={{ transform: 'scale(0.85)', transformOrigin: 'left' }}>
                        <div style={{ width: '119%' }}>{props.riskDataItem.comment}</div>
                    </div>
                </div>
            </div>
        </div>
    )
}

const Current = (props: { style?: CSSProperties; originCenter?: boolean }) => {
    if (props.originCenter) {
        return (
            <div style={{ ...{ width: 12, height: 12, transform: 'rotate(45deg)', transformOrigin: 'center' }, ...props.style }}>
                <div style={{ width: '100%', height: '100%', background: '#231815', marginTop: 3, marginLeft: 4 }}></div>
            </div>
        )
    } else {
        return (
            <div style={{ ...{ width: 12, height: 12, transform: 'rotate(45deg)', transformOrigin: 'center', background: '#231815' }, ...props.style }}></div>
        )
    }
}

const SomeGeneration = (props: { style?: CSSProperties }) => {
    return (
        <div
            style={{
                ...{
                    width: 12,
                    height: 12,
                    background: 'white',
                    border: 'solid 1px #231815',
                    transformOrigin: 'center',
                    transform: 'rotate(45deg)',
                },
                ...props.style,
            }}
        ></div>
    )
}

const Previous = (props: { style?: CSSProperties; originCenter?: boolean }) => {
    if (props.originCenter) {
        return (
            <div style={{ ...{ width: 12, height: 12, transform: 'rotate(45deg)', transformOrigin: 'center' }, ...props.style }}>
                <div style={{ width: '100%', height: '100%', background: '#B4B4B5', border: 'solid 1px #231815', marginTop: 3, marginLeft: 4 }}></div>
            </div>
        )
    } else {
        return (
            <div
                style={{
                    ...{
                        width: 12,
                        height: 12,
                        background: '#B4B4B5',
                        border: 'solid 1px #231815',
                        transformOrigin: 'center',
                    },
                    ...props.style,
                }}
            ></div>
        )
    }
}

const Previous2 = (props: { style?: CSSProperties; originCenter?: boolean }) => {
    if (props.originCenter) {
        return (
            <div style={{ ...{ width: 12, height: 12, transformOrigin: 'center' }, ...props.style }}>
                <div style={{ width: '100%', height: '100%', background: '#DBDCDC', border: 'solid 1px #231815', marginTop: 3, marginLeft: 4 }}></div>
            </div>
        )
    } else {
        return (
            <div
                style={{
                    ...{
                        width: 14,
                        height: 14,
                        background: '#DBDCDC',
                        border: 'solid 1px #231815',
                        borderRadius: 12,
                        transformOrigin: 'center',
                    },
                    ...props.style,
                }}
            ></div>
        )
    }
}
